import { AgentChatPanel } from '@components/agentChat/AgentChatPanel';
import { agentPanelOpenAtom } from '@hooks/agentPanelAtoms';
import { Box, Stack } from '@mui/material';
import { useAtomValue } from 'jotai';
import { PropsWithChildren } from 'react';
import { OrganizationExpirationWrapper } from '../../subsets/landing-page/organization/expiration';
import { Header } from './header';
import { SideNav } from './sideNav';

export const PageLayout = ({ children, fullWidth }: PropsWithChildren<{ fullWidth?: boolean }>) => {
  const panelOpen = useAtomValue(agentPanelOpenAtom);

  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
        display: 'grid',
        gridTemplateRows: 'min-content auto',
        gridTemplateColumns: `min-content 1fr ${panelOpen ? 'clamp(400px, 20vw, 20vw)' : '0px'}`,
        transition: 'grid-template-columns 0.3s ease-in-out, grid-template-rows 0.3s ease-in-out',
      }}
    >
      <Header />
      <SideNav />
      <Stack
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          pl: fullWidth ? 0 : 8,
          pr: fullWidth ? 0 : 4,
          pt: 4.5,
        }}
      >
        {children}

        <OrganizationExpirationWrapper />
      </Stack>

      {/* Agent chat panel — always mounted, clipped by grid column at 0px */}
      <Box sx={{ overflow: 'hidden', height: '100%' }}>
        <AgentChatPanel />
      </Box>
    </Box>
  );
};
